import { render } from "./WebsitePresentations.vue?vue&type=template&id=d6dc411c&scoped=true"
import script from "./WebsitePresentations.vue?vue&type=script&lang=js"
export * from "./WebsitePresentations.vue?vue&type=script&lang=js"

import "./WebsitePresentations.vue?vue&type=style&index=0&id=d6dc411c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6dc411c"]])

export default __exports__